const firebaseConfig = {
  apiKey: "AIzaSyAyXKIegIMoBOOpUPwkZ8ugV3fr08WDAso",
  authDomain: "crypto-spartans.firebaseapp.com",
  projectId: "crypto-spartans",
  storageBucket: "crypto-spartans.appspot.com",
  messagingSenderId: "974505204058",
  appId: "1:974505204058:web:59a6d38a0f9f6539417b63"
};

export default firebaseConfig;